export default `-----BEGIN PUBLIC KEY-----
MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDCLDM6ktRjDwQ2RBq2Z22HyvG9
bY2/fpMx1eavLqHh/8xZI4U5Rs6z31YM/lLeM8uJhpr6cmk1eNVgJOCJasMaWHAa
bCXQlJyhmmn4i3gNVUERGCIaP/zDaRQxlAP2cM885QRfecWOtZOnelRdlZXAYrr8
KUQ9q50qBafX/iebQQIDAQAB
-----END PUBLIC KEY-----`